<ng-container>
    <div *ngIf="isRoot">
        <span class="layout-menuitem-text">{{menuItem.label}}</span>
    </div>
    <ng-container *ngIf="!isRoot">
        <a [attr.href]="menuItem.url" (click)="itemClick($event)" *ngIf="!menuItem.routerLink || menuItem.items" (keydown.enter)="itemClick($event)" [attr.target]="menuItem.target"
            [attr.tabitemIndex]="0" [ngClass]="menuItem.class" (mouseenter)="onMouseEnter()" [pTooltip]="menuItem.label"
            [tooltipDisabled]="isActive || !(isRoot && applicationServiceExt.isSidebarSlim && !applicationServiceExt.isMobile)">
            <i [ngClass]="menuItem.icon" class="layout-menuitem-icon"></i>
            <span class="layout-menuitem-text">{{menuItem.label}}</span>
            <span class="p-badge p-component p-badge-no-gutter" [ngClass]="menuItem.badgeClass" *ngIf="menuItem.badge && !isRoot">{{menuItem.badge}}</span>
            <i class="pi pi-fw pi-angle-down layout-submenu-toggler" *ngIf="menuItem.items"></i>
        </a>
        <a (click)="itemClick($event)" *ngIf="menuItem.routerLink && !menuItem.items" routerLinkActive="active-menuitem-routerlink" [routerLinkActiveOptions]="{exact: true}"
            [attr.target]="menuItem.target" [attr.tabindex]="0" [ngClass]="menuItem.class" (mouseenter)="onMouseEnter()" [pTooltip]="menuItem.label"
            [tooltipDisabled]="isActive || !(isRoot && applicationServiceExt.isSidebarSlim && !applicationServiceExt.isMobile)">
            <i [ngClass]="menuItem.icon" class="layout-menuitem-icon"></i>
            <span class="layout-menuitem-text">{{menuItem.label}}</span>
            <span class="p-badge p-component p-badge-no-gutter" [ngClass]="menuItem.badgeClass" *ngIf="menuItem.badge && !isRoot">{{menuItem.badge}}</span>
            <i class="pi pi-fw pi-angle-down layout-submenu-toggler" *ngIf="menuItem.items"></i>
        </a>
    </ng-container>
    <ul *ngIf="(menuItem.items && isRoot) || (menuItem.items && isActive)" [@children]="isRoot ? 'visible' : isActive ? 'visibleAnimated' : 'hiddenAnimated'">
        <ng-template ngFor let-child let-i="index" [ngForOf]="menuItem.items">
            <li pin-it-track-web-app-menuitem [menuItem]="child" [menuItemIndex]="i" [parentKey]="key" [class]="child.badgeClass"></li>
        </ng-template>
    </ul>
</ng-container>
